import { render } from "./Airport.vue?vue&type=template&id=c6af9618"
import script from "./Airport.vue?vue&type=script&lang=js"
export * from "./Airport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__